var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-component",class:[{ primary: _vm.primary }, `text-component-align-${_vm.align}`],style:(_vm.getStyleObject)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }